export const slide9 = {
  on: {
    CLICK_NEXT: 'slide12',
  },
  meta: {
    id: 'slide9',
    section: '65f0218666c26d474c6cd587',
    event: 'CLICK_NEXT',
    display: {
      backgroundColor: '',
      backgroundGradient: 'linear-gradient(119deg, #FDE8EB 0%, #FFCD14 100%)',
      backgroundImage: '',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-no-repeat',
      backgroundOpacity: 1,
      backgroundVideo: '',
      transition: 'slide',
      transitionSpeed: 'default',
      backgroundTransition: 'fade',
    },
    content: [
      {
        name: 'image',
        type: 'content',
        content: {
          src: 'https://res.cloudinary.com/dcodkxpej/image/upload/v1709802375/Decision%20making%20game/girls/Group_36540_lisgkw.svg',
          height: '135px',
          width: '133px',
        },
      },
      {
        name: 'base_text',
        type: 'content',
        content: {
          text: 'יואו, אתם לא מאמינים איך סבתא\n שמחה. היא גם הציעה שנשמור\n את הארטיקים אצלה במקפיא. זה\n יחסוך המון לוגיסטיקה.',
          footer: 'יאללה להתלבטות הבאה...',
        },
      },
    ],
  },
};

export default slide9;
